<mat-sidenav-container class="sidenav-container">
    @if (store.isAuthenticated()) {
        <mat-sidenav mode="side"
                     [opened]="store.isSidenavOpen()"
                     class="sidenav">
            <mat-nav-list class="sidenav-nav">
                @for (item of store.visibleNav(); track item.label) {
                    @if (item.children) {
                        <mat-expansion-panel class="nav-expansion-panel"
                                             [expanded]="store.expandedNavGroupLabel() === item.label"
                                             [attr.data-test-id]="item.testId ?? null">
                            <mat-expansion-panel-header>
                                <mat-panel-title class="nav-expansion-title">
                                    @if (item.icon) {
                                        <mat-icon>{{ item.icon }}</mat-icon>
                                    }
                                    {{ item.label }}
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <mat-nav-list class="nav-subitem-list">
                                @for (child of item.children; track child.label) {
                                    <a mat-list-item
                                       class="nav-subitem"
                                       [routerLink]="child.route"
                                       routerLinkActive="nav-active"
                                       [attr.data-test-id]="child.testId ?? null">
                                        <span matListItemTitle>{{ child.label }}</span>
                                    </a>
                                }
                            </mat-nav-list>
                        </mat-expansion-panel>
                    } @else {
                        <a mat-list-item
                           [routerLink]="item.route"
                           routerLinkActive="nav-active"
                           [attr.data-test-id]="item.testId ?? null">
                            @if (item.icon) {
                                <mat-icon matListItemIcon>{{ item.icon }}</mat-icon>
                            }
                            <span matListItemTitle>{{ item.label }}</span>
                        </a>
                    }
                }
            </mat-nav-list>
        </mat-sidenav>
    }

    <mat-sidenav-content>
        @if (store.isAuthenticated()) {
            <mat-toolbar class="app-toolbar">
                <button mat-icon-button
                        type="button"
                        (click)="store.toggleSidenav()">
                    <mat-icon>menu</mat-icon>
                </button>
                <span>Nanny Admin</span>
                <span class="toolbar-spacer"></span>
                <!-- Staff assigned to a single country get a label, not a picker that cannot pick. -->
                @if (store.canSwitchCountry()) {
                    <mat-select [value]="store.activeCountry()"
                                (selectionChange)="onCountryChange($event.value)"
                                class="country-select"
                                data-test-id="app-country-select">
                        @for (country of store.availableCountries(); track country) {
                            <mat-option [value]="country">{{ countryLabels[country] }}</mat-option>
                        }
                    </mat-select>
                } @else {
                    <span class="country-label"
                          data-test-id="app-country-label">{{ countryLabels[store.activeCountry()] }}</span>
                }
                <na-status-chip class="env-chip"
                                [label]="store.apiEnvironmentLabel()"
                                [tone]="store.apiEnvironmentTone()"
                                [tooltip]="store.apiBaseUrl()"
                                testId="app-env-chip" />
                <!-- Gated on the name itself: a token without a `name` claim would otherwise leave a bare
                     icon next to an empty span, which reads as a broken render. -->
                @if (store.userName(); as userName) {
                    <span class="toolbar-user">
                        <mat-icon class="toolbar-user-icon">person</mat-icon>
                        <!-- The test id sits on the name span so E2E reads the name alone, not the icon ligature. -->
                        <span class="toolbar-user-name"
                              [matTooltip]="userName"
                              data-test-id="app-current-user">{{ userName }}</span>
                    </span>
                }
                <!-- Icon and tooltip both name the scheme the click switches TO, so the control reads
                     as an action rather than an indicator of the current one. -->
                <button mat-icon-button
                        type="button"
                        (click)="store.toggleTheme()"
                        [matTooltip]="store.themeToggleLabel()"
                        [attr.aria-label]="store.themeToggleLabel()"
                        data-test-id="app-theme-toggle">
                    <mat-icon>{{ store.themeToggleIcon() }}</mat-icon>
                </button>
                <button mat-icon-button
                        type="button"
                        (click)="logout()"
                        title="Exit">
                    <mat-icon>logout</mat-icon>
                </button>
            </mat-toolbar>
        }

        <main class="main-content">
            <router-outlet />
        </main>
    </mat-sidenav-content>
</mat-sidenav-container>

@if (store.isAuthenticated()) {
    <na-ai-agent-chat-panel />
}
